<div *ngIf="cell.inputType == 'inputNumber'">
    <input class="input-class" [ngClass]="(validationCheck) ? 'validationCheckPositive' : 'validationCheckNegative'"
        autoComplete="off" [(ngModel)]="value" (keyup)="valueChanged()" (keypress)="onKeyFunc($event)" type="number"
        [disabled]="cell.disabled">
</div>
<div *ngIf="cell.inputType == 'labelText'">
    <mat-label title="{{value}}">
        {{getLabelText()}}
    </mat-label>
</div>